export default defineNuxtRouteMiddleware(async (to) => {
    const authStore = useAuthStore();
    const { authenticated } = storeToRefs(authStore);
    const token = useCookie<string | null>('token', { path: '/' });

    // PATCH: Toujours essayer d'initialiser depuis les cookies/localStorage
    if (token.value && !authStore.user) {
        await authStore.initializeFromCookies();
    }

    const hasToken = token.value || (process.client && localStorage.getItem('auth_token'));

    if (hasToken) {
        // Valider le token côté serveur pour s'assurer qu'il est encore valide
        try {
            const isValid = await (authStore as any).validateToken();
            if (isValid) {
                authenticated.value = true;
            } else {
                // Token invalide, nettoyer et rediriger
                authStore.logUserOut();
                authenticated.value = false;
                const profileStore = useProfileStore();
                profileStore.clearProfile();

                // Rediriger vers login si on n'y est pas déjà
                if (to?.name !== 'auth-login' && to?.name !== 'auth-login-encrypted' && to?.name !== 'auth-acces-refuse' && to?.name !== 'auth-request-password-reset' && to?.name !== 'auth-recover-password') {
                    return navigateTo('/auth/login');
                }
            }
        } catch (error) {
            // Erreur de validation, nettoyer et rediriger
            authStore.logUserOut();
            authenticated.value = false;
            const profileStore = useProfileStore();
            profileStore.clearProfile();

            if (to?.name !== 'auth-login' && to?.name !== 'auth-login-encrypted' && to?.name !== 'auth-acces-refuse' && to?.name !== 'auth-request-password-reset' && to?.name !== 'auth-recover-password') {
                return navigateTo('/auth/login');
            }
        }
    } else {
        // Si pas de token, nettoyer l'état d'authentification et le profil
        authenticated.value = false;
        const profileStore = useProfileStore();
        profileStore.clearProfile();
    }

    // if token exists and url is /login redirect based on user type
    if (hasToken && authenticated.value && (to?.name === 'auth-login' || to?.name === 'auth-login-encrypted')) {
        const profileStore = useProfileStore();
        if (!profileStore.profile) {
            try {
                await profileStore.fetchProfile();
            } catch {
                return navigateTo('/auth/acces-refuse', { replace: true });
            }
        }
        const { homePath } = useHomePath();
        const dest = homePath();
        if (to.path !== dest) {
            return navigateTo(dest, { replace: true });
        }
    }

    // if token doesn't exist redirect to log in
    if (!hasToken && to?.name !== 'auth-login' && to?.name !== 'auth-login-encrypted' && to?.name !== 'auth-acces-refuse' && to?.name !== 'auth-request-password-reset' && to?.name !== 'auth-recover-password') {
        return navigateTo('/auth/login');
    }
});